import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import {
  updateJiraMappingsInTemplateAction,
  UpdateJiraMappingsInTemplateAction,
} from '../actions';
import { updateJiraMappingInTemplate } from '../slices';

function* updateJiraMappingsInTemplateSaga(
  action: StoreActionProps<UpdateJiraMappingsInTemplateAction>,
) {
  try {
    const {
      payload: { taskId, data },
    } = action;

    yield put(updateJiraMappingInTemplate({ taskId, data }));
  } catch (error) {
    message.error(
      'There was an error on updating jira config',
      error as unknown as any,
    );
  }
}

export function* watchUpdateJiraMappingsInTemplateSaga(): Generator {
  yield takeLatest(
    updateJiraMappingsInTemplateAction.type,
    updateJiraMappingsInTemplateSaga,
  );
}
